import { initLoader, hideLoader } from "@/modules/loader/loader";
import axios from "axios";
import { CLASSES } from "@/scripts/helpers/constants";

const fieldHeader = $(".js-search-header-page");
const fieldPage = $(".js-search-page");
const fieldMobile = $(".js-search-header-mobile");
const resultLabel = $(".search-result");
const hasError = "has-error";
let targetIndex = 1;
let clickFlag = false;
const totalPages = Math.ceil(parseInt(resultLabel.text()) / 10);
let countPagination = 1;
totalPages >= 10 ? (countPagination = 10) : (countPagination = totalPages);
const pageUrl = window.location;

$(".search-banner__text").text(
  `Your search "${fieldPage.val()}" – did not match any answers we have 😬"`
);

fieldPage.keypress(function(e) {
  const query = $(this).val();
  handleSearch(e, query);
});

fieldMobile.keypress(function(e) {
  const query = $(this).val();
  handleSearchToPage(e, query);
});

fieldHeader.keypress(function(e) {
  const query = $(this).val();
  handleSearchToPage(e, query);
});

fieldPage.focusin(function(e) {
  clickFlag = false;
});

const handleSearchToPage = (e, query) => {
  const key = e.which;

  $(e.target).removeClass(hasError);

  if (key === 13) {
    if (query.length) {
      window.location.href = window.location.origin + "/search?q=" + query;
    } else {
      resultLabel.html("This field may not be empty.");
      resultLabel.addClass(hasError);
      $(e.target).addClass(hasError);
    }
  }
};

const handleSearch = (e, query, pageIndex = 1) => {
  const key = e.which;

  $(e.target).removeClass(hasError);

  if (key === 13) {
    targetIndex = 1;
  }

  if (key === 13 || clickFlag) {
    if (query.length) {
      window.history.pushState({}, "", `search?q=${query}`);
      initLoader($(".loader"));

      axios
        .get(`/search/ajaxSearchInGoogle?q=${query}&page=${pageIndex}`)
        .then(res => {
          if (res.request.responseURL.includes("captcha")) {
            window.location.href = `/captcha?ref=${pageUrl.href}`;
          } else {
            hideLoader($(".loader"));
            renderResults(res.data, query);

            if (res.data.searchInformation) {
              const totalResponsePages = Math.ceil(
                parseInt(res.data.searchInformation.totalResults) / 10
              );
              totalResponsePages >= 10
                ? (countPagination = 10)
                : (countPagination = totalResponsePages);
              renderPagination(countPagination);
            }
          }
        })
        .catch(error => {
          console.error(error);
        });

      return false;
    } else {
      resultLabel.html("This field may not be empty.");
      resultLabel.addClass(hasError);
      $(e.target).addClass(hasError);
    }
  }
};

const renderResults = (res, query) => {
  if (res.items) {
    outputSucces(res);
  } else {
    outputEmpty(query);
  }
};

const outputSucces = res => {
  $(".search-list").show();

  let listItem = ``;

  res.items.forEach(item => {
    listItem += `<li class="search-list__item">
                    <a class="search-list__item-title" href="${item.link}">${
      item.title
    }</a>
                    <p class="search-list__item-description">${item.snippet}</p>
                    <a class="search-list__item-link" href="${
                      item.link
                    }">${item.link.slice(8)}</a>
                  </li>`;
  });

  $(".search-list")
    .first()
    .html(`${listItem}`);
  resultLabel.html(`${res.searchInformation.totalResults} results found`);
  $("#info-block-for-empty-result").hide();
  $(".search-list")
    .first()
    .show();
  $(".form-catalog-pagination").show();
  resultLabel.removeClass(hasError);
};

const outputEmpty = query => {
  $("#info-block-for-empty-result").show();
  $(".search-list")
    .first()
    .hide();
  $(".form-catalog-pagination").hide();
  $(".search-banner__text").text(
    `Your search "${query}" – did not match any answers we have 😬`
  );
  resultLabel.html(`0 results found`);
  resultLabel.removeClass(hasError);
};

const renderPagination = countPagination => {
  let paginationListItem = ``;

  pagination(targetIndex, countPagination).forEach(value => {
    paginationListItem += `<li class="pagination__item ${
      targetIndex === value ? "is-active" : ""
    }">
                <a class="pagination__link" href="#" aria-label="Go to page ${value}">${value}</a>
              </li>`;
  });

  $(".pagination__list")
    .html(`<li class="pagination__item pagination__item--backward ${
    targetIndex === 1 ? CLASSES.IS_DISABLED : ""
  }">
            <a class="pagination__link" href="#" aria-label="Go to page 1">Prev</a>
          </li>
           ${paginationListItem}
          <li class="pagination__item pagination__item--forward ${
            targetIndex === countPagination ? CLASSES.IS_DISABLED : ""
          }">
            <a class="pagination__link" href="#" aria-label="Go to page 2">Next</a>
          </li>`);

  $(".pagination__link").each(function() {
    if ($(this).html() === "...") {
      $(this).addClass(CLASSES.IS_DISABLED);
    }
  });
};

if (fieldPage.length) {
  renderPagination(countPagination);
  $(".pagination__list li:nth-child(2)").addClass(CLASSES.IS_ACTIVE);

  const nextButton = "pagination__item--forward";
  const prevButton = "pagination__item--backward";
  $(`.${prevButton}`).addClass(CLASSES.IS_DISABLED);

  $(".pagination__list").on("click", e => {
    if (e.target.nodeName.toLocaleLowerCase() === "a") {
      e.preventDefault();
      clickFlag = true;
      const query = fieldPage.val();

      $(".pagination__item").removeClass(CLASSES.IS_ACTIVE);

      //click on numbers
      if (
        typeof +$(e.target).text() === "number" &&
        !$(e.target)
          .parent()
          .hasClass(nextButton) &&
        !$(e.target)
          .parent()
          .hasClass(prevButton)
      ) {
        targetIndex = +$(e.target).text();

        targetIndex > 1
          ? $(`.${prevButton}`).removeClass(CLASSES.IS_DISABLED)
          : $(`.${prevButton}`).addClass(CLASSES.IS_DISABLED);

        targetIndex === countPagination
          ? $(`.${nextButton}`).addClass(CLASSES.IS_DISABLED)
          : $(`.${nextButton}`).removeClass(CLASSES.IS_DISABLED);
      }

      //click on next button
      if (
        $(e.target)
          .parent()
          .hasClass(nextButton)
      ) {
        ++targetIndex;

        $(e.target)
          .parent()
          .removeClass(CLASSES.IS_ACTIVE);
        $(`.${prevButton}`).removeClass(CLASSES.IS_DISABLED);

        if (targetIndex >= countPagination) {
          $(`.${nextButton}`).addClass(CLASSES.IS_DISABLED);
        }
      }

      //click on prev button
      if (
        $(e.target)
          .parent()
          .hasClass(prevButton)
      ) {
        --targetIndex;

        $(e.target)
          .parent()
          .removeClass(CLASSES.IS_ACTIVE);
        $(`.${nextButton}`).removeClass(CLASSES.IS_DISABLED);

        if (targetIndex <= 1) {
          $(`.${prevButton}`).addClass(CLASSES.IS_DISABLED);
        }
      }

      $(".pagination__link").each(function() {
        if (parseInt($(this).html()) === targetIndex) {
          $(this)
            .parent()
            .addClass(CLASSES.IS_ACTIVE);
        }
      });

      handleSearch(e, query, targetIndex);
    }
  });
}

//Numbers
function pagination(start, totalPages) {
  const currentItem = start;
  const lastItem = totalPages;
  const delta = 3;
  const left = currentItem - delta;
  const right = currentItem + delta + 1;
  const range = [];
  const rangeWithDots = [];
  let l = null;

  for (let i = 1; i <= lastItem; i++) {
    if (i == 1 || i == lastItem || (i >= left && i < right)) {
      range.push(i);
    }
  }

  for (let i of range) {
    if (l) {
      if (i - l === 2) {
        rangeWithDots.push(l + 1);
      } else if (i - l !== 1) {
        rangeWithDots.push("...");
      }
    }
    rangeWithDots.push(i);
    l = i;
  }

  return rangeWithDots;
}

if ($(window).width() <= 639 && !$("html").attr("lang") === "fr") {
  fieldMobile.attr("placeholder", "Find anything");
  fieldHeader.attr("placeholder", "Find anything");
  fieldPage.attr("placeholder", "Find anything");
}
